<div class="lead-dialog" [dir]="languageService.getPageDirection()">
  <div class="lead-dialog-header">
    <h2>{{ "appointments.gui.labels.leads.New Lead" | translate }}</h2>
    <button class="lead-dialog-close" (click)="close()">&times;</button>
  </div>

  <div class="lead-dialog-grid">
    <label>
      <span>{{ "appointments.gui.labels.First Name" | translate }} *</span>
      <input class="t-field" [(ngModel)]="lead.First" />
    </label>
    <label>
      <span>{{ "appointments.gui.labels.Last Name" | translate }} *</span>
      <input class="t-field" [(ngModel)]="lead.Last" />
    </label>
    <label>
      <span>{{ "billing.gui.placeholders.ID Number" | translate }}</span>
      <input class="t-field" [(ngModel)]="lead.ID" />
    </label>
    <label>
      <span>{{ "appointments.gui.labels.Mobile" | translate }} *</span>
      <input class="t-field" [(ngModel)]="lead.Mobile" />
    </label>
    <label>
      <span>{{ "appointments.gui.labels.Email" | translate }}</span>
      <input class="t-field" type="email" [(ngModel)]="lead.Email" />
    </label>
    <label>
      <span>{{ "appointments.gui.labels.Birth Date" | translate }}</span>
      <input
        [matDatepicker]="birthPicker"
        [(ngModel)]="lead.Birth"
        (click)="birthPicker.open()"
        class="t-field t-field--date menstural-field"
      />
      <mat-datepicker #birthPicker></mat-datepicker>
    </label>
    <label>
      <span>{{ "appointments.gui.labels.Gender" | translate }}</span>
      <select class="t-field" [(ngModel)]="lead.Sex">
        <option value=""></option>
        <option value="M">{{ "appointments.gui.selects.Male" | translate }}</option>
        <option value="F">{{ "appointments.gui.selects.Female" | translate }}</option>
      </select>
    </label>
    <label>
      <span>{{ "appointments.gui.labels.Payer" | translate }}</span>
      <select class="t-field" [(ngModel)]="lead.HMO">
        <option value=""></option>
        <option *ngFor="let hmo of hmoOptions" [value]="hmo">{{ "appointments.gui.labels." + hmo | translate }}</option>
      </select>
    </label>
    <label class="lead-dialog-wide">
      <span>{{ "appointments.gui.labels.leads.Note" | translate }}</span>
      <textarea class="t-field lead-note" rows="3" [(ngModel)]="lead.Note"></textarea>
    </label>
  </div>

  <p *ngIf="error == 'required'" class="lead-dialog-error">{{ "appointments.gui.labels.leads.Required Fields" | translate }}</p>
  <p *ngIf="error == 'error'" class="lead-dialog-error">{{ "appointments.gui.labels.leads.Save Error" | translate }}</p>

  <div class="lead-dialog-footer">
    <button class="orange-btn" [disabled]="saving" (click)="save()">{{ "appointments.gui.buttons.Save" | translate }}</button>
    <button class="blue-btn" (click)="close()">{{ "appointments.gui.buttons.Cancel" | translate }}</button>
  </div>
</div>
